<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAddSomeone_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M13 1.833a.5.5 0 0 1 .5.5V3.5h1.167a.5.5 0 1 1 0 1H13.5v1.167a.5.5 0 1 1-1 0V4.5h-1.167a.5.5 0 1 1 0-1H12.5V2.333a.5.5 0 0 1 .5-.5M7.333 8.391c1.352 0 2.452-1.099 2.452-2.452 0-1.351-1.1-2.45-2.452-2.45a2.454 2.454 0 0 0-2.452 2.45c0 1.352 1.1 2.452 2.452 2.452m4.014 2.24c-.64-.684-1.844-1.192-4.014-1.192-2.188 0-3.395.516-4.03 1.209l-.018.02c-.172.187-.45.489-.565 1.231a.67.67 0 0 0 .661.768h7.904a.67.67 0 0 0 .662-.768c-.12-.757-.405-1.061-.59-1.258z"
        clip-rule="evenodd"
    />
</svg>
